import { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import {
  getSharedDocumentContent,
  getSharedDocumentsErrorMessage,
} from "../../redux/api/Appoinment/SharedDocumentsApi";

// View-only modal for a shared document; the object URL is revoked on close.
export default function SharedDocumentViewer({ appointmentId, doc, onClose }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!doc) {
      // Reset on close; the modal keeps rendering during its close animation.
      setUrl(null);
      setError(null);
      setLoading(false);
      return undefined;
    }
    let objectUrl = null;
    let cancelled = false;
    setLoading(true);
    setError(null);
    setUrl(null);

    getSharedDocumentContent(appointmentId, doc.documentId)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(
          new Blob([blob], { type: doc.contentType || blob.type })
        );
        setUrl(objectUrl);
      })
      .catch(async (err) => {
        if (cancelled) return;
        setError(
          (await getSharedDocumentsErrorMessage(err)) ||
            "Unable to open this document. Please try again."
        );
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [appointmentId, doc]);

  const isPdf = doc?.contentType === "application/pdf";

  return (
    <Modal
      open={!!doc}
      onCancel={onClose}
      footer={null}
      width="80vw"
      centered
      destroyOnClose
      zIndex={10000}
      title={
        <span className="font-poppins text-[16px] font-semibold text-[#171717]">
          {doc?.title}
        </span>
      }
    >
      <div
        className="flex items-center justify-center bg-[#EFF6FF] rounded-lg h-[75vh] overflow-auto select-none"
        onContextMenu={(e) => e.preventDefault()}
      >
        {loading && <Spin />}
        {!loading && error && (
          <p className="font-poppins text-sm text-[#334155]">{error}</p>
        )}
        {!loading && doc && url && isPdf && (
          <iframe
            src={`${url}#toolbar=0`}
            title={doc.title}
            className="w-full h-full border-0"
          />
        )}
        {!loading && doc && url && !isPdf && (
          <img
            src={url}
            alt={doc.title}
            draggable={false}
            className="max-w-full max-h-full object-contain"
          />
        )}
      </div>
    </Modal>
  );
}
